import mapKeys from 'lodash/mapKeys';

export const keysFirstLetterToLower = <T>(obj: object) => {
  return mapKeys(obj, (value, key) => {
    return `${key}`.charAt(0).toLowerCase() + key.slice(1);
  }) as T;
};
